/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { BaseEndpoints } from './base.endpoints';
import { IApiKey } from './api-interfaces';

export class ApiKeyEndpoints extends BaseEndpoints<IApiKey> {
  constructor(client: Client) {
    super(client, 'apikeys');
  }
}
